export default __webpack_public_path__ + "static/media/52.b4aa4ba0.jpg";